import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loading from 'components/shared-components/Loading';
import {
  AUTH_PREFIX_PATH,
  UNAUTHENTICATED_ENTRY,
  REDIRECT_URL_KEY,
} from 'configs/AppConfig';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import { useGetProfileQuery } from 'services/authApi';
import { signOutSuccess } from 'store/slices/authSlice';
import {
  ADS_MANAGER_DEFAULT_PATH,
  getAdminViewerWriteRedirectPath,
  isAdminPanelUser,
  isAdminViewer,
  isAdsManager,
  isPathAllowedForAdsManager,
  isWritePathBlockedForAdminViewer,
} from 'utils/adminAccess';

const ProtectedRoute = () => {
  const dispatch = useDispatch();
  const { token, user } = useSelector((state) => state.auth);
  const location = useLocation();
  const { data: profile, isLoading } = useGetProfileQuery(undefined, {
    skip: !token,
  });
  const currentUser = user || profile;

  if (!token) {
    return (
      <Navigate
        to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${location.pathname}`}
        replace
      />
    );
  }

  if (!currentUser && isLoading) {
    return <Loading cover="page" />;
  }

  if (currentUser && !isAdminPanelUser(currentUser)) {
    localStorage.removeItem(AUTH_TOKEN);
    dispatch(signOutSuccess());
    return (
      <Navigate to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}`} replace />
    );
  }

  if (
    currentUser &&
    isAdsManager(currentUser) &&
    !isPathAllowedForAdsManager(location.pathname)
  ) {
    return <Navigate to={ADS_MANAGER_DEFAULT_PATH} replace />;
  }

  if (
    currentUser &&
    isAdminViewer(currentUser) &&
    isWritePathBlockedForAdminViewer(location.pathname)
  ) {
    return (
      <Navigate
        to={getAdminViewerWriteRedirectPath(location.pathname)}
        replace
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
